import { ArticleHeading4 } from '@cian/ui-kit';
import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import styles from './styles.css';

export interface IEntryBannerProps {
  text?: string;
  onClick: VoidFunction;
}

export const EntryBanner: React.FC<IEntryBannerProps> = ({ text, onClick }) => {
  return (
    <div className={styles['container']} onClick={onClick}>
      <div className={styles['house']} />
      <div className={styles['text']}>
        <ArticleHeading4>{text}</ArticleHeading4>
      </div>
      <div className={styles['arrow']}>
        <IconActionChevronRight16 color="icon-secondary-default" display="block" />
      </div>
    </div>
  );
};
